// extracted by mini-css-extract-plugin
module.exports = {"showMoreContainer":"ShowMoreContent_showMoreContainer__1pqGV","isShowMoreClicked":"ShowMoreContent_isShowMoreClicked__29llS","showMoreLink":"ShowMoreContent_showMoreLink__1-0G0"};